module.exports = __webpack_public_path__ + "img/51_51.0860f5b9.png";